// Meta (Facebook) Pixel helper.
// Mirrors the official Meta Pixel base code, wrapped so we can call it from React.

export const META_PIXEL_ID = '2782604225446367'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

/**
 * Injects the Meta Pixel base script and initializes it.
 * Safe to call multiple times — it only runs once.
 */
export function initMetaPixel(pixelId: string = META_PIXEL_ID) {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      // Fallback for environments with no existing <script> sibling.
      ;(b.head || b.documentElement).appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  window.fbq('init', pixelId)
}

/** Fires the standard PageView event. */
export function trackPageView() {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'PageView')
}

/** Fires a standard event (e.g. 'AddToCart') with optional parameters. */
export function trackEvent(event: string, params?: Record<string, unknown>) {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', event, params)
}
